/* Parsing what people type into optional number fields. */

/**
 * '' → null (the field was left blank, which means "any" or "not stated");
 * a positive number → that number; anything else → undefined (invalid).
 * Three outcomes, so a caller can tell "blank" from "wrong".
 */
export function parseOptionalPositive(raw: string, integer = false): number | null | undefined {
  const v = raw.trim()
  if (v === '') return null
  const n = Number(v)
  if (Number.isNaN(n) || n <= 0 || (integer && !Number.isInteger(n))) return undefined
  return n
}
